import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { reportErrorToLogFetch } from 'academy-common-lib/utils/errorUtils';
import RestartExerciseModal from './RestartExerciseModal';
import RetakePracticalExerciseModal from './RetakePracticalExerciseModal';
import UsageTracker from '../../../utils/UsageTracker';
import { useDeletePracticalExerciseProgress } from '../practicalExerciseQueries';
import { ContactUsLink } from '../../../components/ContactUsLink';
import { Metrics } from '../../../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PracticalExerciseRetryButtonContainer = ({
  contentId,
  exerciseTypeLabel = 'none',
  flow = 'restart',
  lessonId,
  requiredAccess,
  requiredProduct,
  trackId,
  use = 'secondary'
}) => {
  const [displayModal, setDisplayModal] = useState(false);
  const [isDeletingProgress, setIsDeletingProgress] = useState(false);
  const [deletePracticalExerciseProgress] = useDeletePracticalExerciseProgress();
  const handleClickRetryExercise = () => setDisplayModal(true);
  const handleRejectRetryExercise = () => setDisplayModal(false);
  const handleOnRetryPracticalExercise = id => {
    setIsDeletingProgress(true);
    deletePracticalExerciseProgress({
      contentId: id,
      lessonId,
      trackId
    }).then(() => {
      Metrics.counter('exercise-content-mutation', {
        action: 'practical-exercise-retake-progress-deleted',
        exerciseType: exerciseTypeLabel
      }).increment();
      setIsDeletingProgress(false);
      setDisplayModal(false);
    }).catch(error => {
      Metrics.counter('exercise-mutation-call-error', {
        action: 'practical-exercise-retake-progress-delete-error',
        exerciseType: exerciseTypeLabel
      }).increment();
      reportErrorToLogFetch({
        loggingTitle: 'Practical Exercise Retake Delete Progress Error',
        action: 'practical-exercise-retake-progress-delete-error',
        error,
        additionalData: {
          contentId: id,
          lessonId,
          trackId
        }
      });
      FloatingAlertStore.addAlert({
        type: 'danger',
        message: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.practicalExercise.restartError",
          options: {
            contactUsLink: /*#__PURE__*/_jsx(ContactUsLink, {})
          }
        })
      });
      setIsDeletingProgress(false);
    });
  };
  const handleConfirmRetryExercise = () => {
    UsageTracker.trackStandalone('Content Interaction', {
      action: 'retry-practical-exercise',
      contentId,
      contentType: 'practical-exercise',
      trackId,
      lessonId
    });
    handleOnRetryPracticalExercise(Number(contentId));
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [displayModal && (flow === 'restart' ? /*#__PURE__*/_jsx(RestartExerciseModal, {
      disableConfirm: isDeletingProgress,
      onConfirm: handleConfirmRetryExercise,
      onReject: handleRejectRetryExercise
    }) : /*#__PURE__*/_jsx(RetakePracticalExerciseModal, {
      disableConfirm: isDeletingProgress,
      onConfirm: handleConfirmRetryExercise,
      onReject: handleRejectRetryExercise
    })), /*#__PURE__*/_jsx(Tooltip, {
      disabled: !(requiredProduct || requiredAccess),
      headingText: requiredProduct ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.header`
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredAccess.${requiredAccess}.header`
      }),
      title: requiredProduct ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredProduct.${requiredProduct}.description`
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.practicalExercise.requiredAccess.${requiredAccess}.description`
      }),
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "practical-exercise-retry-button",
        disabled: !!requiredProduct || !!requiredAccess,
        onClick: handleClickRetryExercise,
        use: use,
        children: flow === 'restart' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.retake"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.retry"
        })
      })
    })]
  });
};
export default PracticalExerciseRetryButtonContainer;